const toTime = (value) => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

const activityTime = (conversation) =>
  Math.max(
    toTime(conversation?.lastMessageAt),
    toTime(conversation?.updatedAt)
  );

// Najnovija aktivnost prva.
export const sortConversations = (conversations) =>
  [...conversations].sort((a, b) => activityTime(b) - activityTime(a));

// Ubaci ili osvezi jedan razgovor u listi, pa presortiraj (najnovije prvo).
// Ako razgovor ne postoji u listi, dodaje se (novi razgovor "izroni" na vrh) -
// osim kad je `insertIfMissing` false: tada se samo azuriraju postojeci redovi,
// a nepoznati se ignorisu (koristi se dok je aktivna pretraga, da live update ne
// ubaci razgovor koji ne odgovara upitu - pretragu radi backend).
export const upsertConversation = (
  conversations,
  incoming,
  { insertIfMissing = true } = {}
) => {
  if (!incoming?.id) return conversations;

  const index = conversations.findIndex((item) => item.id === incoming.id);
  if (index < 0 && !insertIfMissing) return conversations;

  let next;
  if (index >= 0) {
    next = [...conversations];
    next[index] = { ...next[index], ...incoming };
  } else {
    next = [incoming, ...conversations];
  }

  return sortConversations(next);
};

// Lokalno postavi broj neprocitanih na 0 za jedan razgovor (kada apoteka otvori
// razgovor - server takodje emituje conversation:updated ostalim nalozima).
export const clearConversationUnread = (conversations, conversationId) =>
  conversations.map((item) =>
    item.id === conversationId ? { ...item, pharmacyUnreadCount: 0 } : item
  );
